
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBusiness = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 29,
  height: 25,
  textRendering: "geometricPrecision",
  viewBox: "0 0 29 25"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAMAAAD63NUrAAAA9lBMVEUkJCQkJCQkJCQkJCQkJCQkJCQkJCRMaXEkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQYjFBuAAAAUXRSTlMwl+7TuFD+AEDwzHywdBK5BP3mFR41A/TUag6Q8wWUgvcK9vWWsgKzbC4cNNUs3N0BWZg3GVi6L8qAK7fv5Png6IXGu4z78aDWzojyTGhxrKUkiUL/AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA6klEQVR42rWQV1fCQBCFJ8luEhNa6L1ExArYFZBqAQGB+///jGQjHDkkT+j3sDN7v4edHdI2xEZw6erbjLbdEBsMDzvGihwW6P+yyYQuYFiKamKgZ5/aIT2R1CiuYJ9wNPoMKHFiUI8E+fe8qB+9Y7nVecy9qGBkgWvecFgEkI911GGWZerXe6p2fhYWdo0cCF5GnDDrHJG74Kks8rU9aYouxcx5Ggo3X1Pi3gj8vHtxc3vlrmHilnT14X5nqhjPGSqmUI03HvKcOYMZvnx/VCh+Fgt/uI3/sjZK5E0JNknwR6KKVPZxZanyDfrWVTCC7f10AAAAAElFTkSuQmCC",
  width: 29,
  height: 25,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAMAAAD63NUrAAAA9lBMVEUkJCQkJCQkJCQkJCQkJCQkJCQkJCRMaXEkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQYjFBuAAAAUXRSTlMwl+7TuFD+AEDwzHywdBK5BP3mFR41A/TUag6Q8wWUgvcK9vWWsgKzbC4cNNUs3N0BWZg3GVi6L8qAK7fv5Png6IXGu4z78aDWzojyTGhxrKUkiUL/AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA6klEQVR42rWQV1fCQBCFJ8luEhNa6L1ExArYFZBqAQGB+///jGQjHDkkT+j3sDN7v4edHdI2xEZw6erbjLbdEBsMDzvGihwW6P+yyYQuYFiKamKgZ5/aIT2R1CiuYJ9wNPoMKHFiUI8E+fe8qB+9Y7nVecy9qGBkgWvecFgEkI911GGWZerXe6p2fhYWdo0cCF5GnDDrHJG74Kks8rU9aYouxcx5Ggo3X1Pi3gj8vHtxc3vlrmHilnT14X5nqhjPGSqmUI03HvKcOYMZvnx/VCh+Fgt/uI3/sjZK5E0JNknwR6KKVPZxZanyDfrWVTCC7f10AAAAAElFTkSuQmCC",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"29\" height=\"25\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 29 25\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAMAAAD63NUrAAAA9lBMVEUkJCQkJCQkJCQkJCQkJCQkJCQkJCRMaXEkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQYjFBuAAAAUXRSTlMwl+7TuFD+AEDwzHywdBK5BP3mFR41A/TUag6Q8wWUgvcK9vWWsgKzbC4cNNUs3N0BWZg3GVi6L8qAK7fv5Png6IXGu4z78aDWzojyTGhxrKUkiUL/AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA6klEQVR42rWQV1fCQBCFJ8luEhNa6L1ExArYFZBqAQGB+///jGQjHDkkT+j3sDN7v4edHdI2xEZw6erbjLbdEBsMDzvGihwW6P+yyYQuYFiKamKgZ5/aIT2R1CiuYJ9wNPoMKHFiUI8E+fe8qB+9Y7nVecy9qGBkgWvecFgEkI911GGWZerXe6p2fhYWdo0cCF5GnDDrHJG74Kks8rU9aYouxcx5Ggo3X1Pi3gj8vHtxc3vlrmHilnT14X5nqhjPGSqmUI03HvKcOYMZvnx/VCh+Fgt/uI3/sjZK5E0JNknwR6KKVPZxZanyDfrWVTCC7f10AAAAAElFTkSuQmCC\" width=\"29\" height=\"25\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAMAAAD63NUrAAAA9lBMVEUkJCQkJCQkJCQkJCQkJCQkJCQkJCRMaXEkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQYjFBuAAAAUXRSTlMwl+7TuFD+AEDwzHywdBK5BP3mFR41A/TUag6Q8wWUgvcK9vWWsgKzbC4cNNUs3N0BWZg3GVi6L8qAK7fv5Png6IXGu4z78aDWzojyTGhxrKUkiUL/AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA6klEQVR42rWQV1fCQBCFJ8luEhNa6L1ExArYFZBqAQGB+///jGQjHDkkT+j3sDN7v4edHdI2xEZw6erbjLbdEBsMDzvGihwW6P+yyYQuYFiKamKgZ5/aIT2R1CiuYJ9wNPoMKHFiUI8E+fe8qB+9Y7nVecy9qGBkgWvecFgEkI911GGWZerXe6p2fhYWdo0cCF5GnDDrHJG74Kks8rU9aYouxcx5Ggo3X1Pi3gj8vHtxc3vlrmHilnT14X5nqhjPGSqmUI03HvKcOYMZvnx/VCh+Fgt/uI3/sjZK5E0JNknwR6KKVPZxZanyDfrWVTCC7f10AAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/business.34bc5b56ad3ad8c60176a2373621c1c7.svg"),
        {
          React: SvgBusiness,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      